import request from "@/utils/request";
import { method } from "lodash";
//上传图片-公有
export function publicUpload(data) {
  return request({
    url: 'zwb/app/oss/public/upload',
    method: 'post',
    data
  })
}

//编辑个人信息
export function personalinfo(data) {
  return request({
    url: 'zwb/app/edit/personalinfo',
    method: 'post',
    data
  })
}
//获取用户角色
export function userAuth(data) {
  return request({
    url: 'zwb/app/get/user/auth',
    method: 'post',
    data
  })
}
//获取账户手机号
export function userphone(params) {
  return request({
    url: 'zwb/app/get/userphone',
    method: 'get',
    params
  })
}
//修改密码前，发送验证码
export function sendSmsCaptcha(params) {
  return request({
    url: 'zwb/app/changepwd/sendSmsCaptcha',
    method: 'get',
    params
  })
}
// 修改密码
export function changePassword(params) {
  return request({
    url: "/zwb/app/changePassword",
    method: "get",
    params
  });
}

//课程详情
export function collegeInfo(params) {
  return request({
    url: 'zwb/app/college/info',
    method: 'get',
    params
  })
}

//邀请码
export function integral(){
  return request({
    url: 'zwb/app/inviteCode',
    method: 'get'
  });
}

//积分详情
export function integralList(data){
  return request({
    url: 'zwb/app/integral/list',
    method: "POST",
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/my.js